// Development fallback database service (no AWS Amplify dependency)

/**
 * Saves form submission to database with standardized error handling
 * @param {Object} formData - The form data to save
 * @param {string} formType - Type of form (photoStudio)
 * @returns {Promise} - Promise with standardized result
 */
export const saveSubmission = async (formData, formType) => {
  try {
    console.log('📝 Simulated database save (development mode):', formData);
    
    return {
      success: true,
      message: 'Submission saved successfully (simulated)',
      data: { id: formData.id || Date.now().toString() },
      timestamp: new Date().toISOString()
    };
  } catch (error) {
    console.error('Error saving submission:', error);
    return {
      success: false,
      message: error.message || 'Failed to save submission',
      error: error.message,
      timestamp: new Date().toISOString()
    };
  }
};

/**
 * Retrieves all form submissions with standardized error handling
 * @returns {Promise} - Promise with standardized result
 */
export const getSubmissions = async () => {
  try {
    console.log('📋 Simulated database fetch (development mode)');
    
    return {
      success: true,
      data: [],
      message: 'Development mode - no submissions stored',
      timestamp: new Date().toISOString()
    };
  } catch (error) {
    console.error('Error fetching submissions:', error);
    return {
      success: false,
      message: error.message || 'Failed to fetch submissions',
      error: error.message,
      timestamp: new Date().toISOString()
    };
  }
};

/**
 * Updates submission status with standardized error handling
 * @param {string} id - Submission ID
 * @param {string} status - New status
 * @param {string} adminEmail - Email of admin making the change
 * @returns {Promise} - Promise with standardized result
 */
export const updateSubmissionStatus = async (id, status, adminEmail) => {
  try {
    console.log('📝 Simulated status update (development mode):', { id, status, adminEmail });
    
    return {
      success: true,
      message: 'Status updated successfully (simulated)',
      data: { id, status, updatedBy: adminEmail },
      timestamp: new Date().toISOString()
    };
  } catch (error) {
    console.error('Error updating status:', error);
    return {
      success: false,
      message: error.message || 'Failed to update status',
      error: error.message,
      timestamp: new Date().toISOString()
    };
  }
};